var map = {
	"./Rectangle.png": "274e",
	"./banner.png": "5b08",
	"./care1.png": "784f",
	"./care2.png": "329b",
	"./care3.png": "4b02",
	"./client1.png": "d3c6",
	"./client10.png": "2655",
	"./client11.png": "eb82",
	"./client12.png": "6f10",
	"./client13.png": "34e1",
	"./client14.png": "2302",
	"./client15.png": "9be0",
	"./client2.png": "be7c",
	"./client3.png": "7574",
	"./client4.png": "5b33",
	"./client5.png": "8385",
	"./client6.png": "9b16",
	"./client7.png": "79a9",
	"./client8.png": "fd80",
	"./client9.png": "b297",
	"./compare1.png": "7b37",
	"./compare2.png": "4008",
	"./dream1.png": "c5d3",
	"./dream2.png": "c950",
	"./dream3.png": "aa80",
	"./dream4.png": "d873",
	"./foot-email.png": "ffb4",
	"./foot-logo-x.png": "2beb",
	"./foot-logo.png": "1333",
	"./foot-social1.png": "4438",
	"./foot-social2.png": "00f4",
	"./foot-tel.png": "aec3",
	"./foot-time.png": "11c7",
	"./foot-wechat.png": "6f34",
	"./guard1.png": "3c7a",
	"./guard2.png": "926e",
	"./guard3.png": "a422",
	"./honor-bg.png": "8080",
	"./honor1.png": "7622",
	"./honor2.png": "a885",
	"./honor3.png": "d285",
	"./honor4.png": "77f2",
	"./honor5.png": "4e87",
	"./hospital1.png": "25c0",
	"./hospital10.png": "127e",
	"./hospital11.png": "f41f",
	"./hospital12.png": "5b77",
	"./hospital13.png": "57f2",
	"./hospital14.png": "089c",
	"./hospital2.png": "1cc8",
	"./hospital3.png": "04fb",
	"./hospital4.png": "ea6f",
	"./hospital5.png": "a633",
	"./hospital6.png": "4b53",
	"./hospital7.png": "ddfe",
	"./hospital8.png": "3916",
	"./hospital9.png": "d465",
	"./intro-bg.png": "cd92",
	"./logo-x.png": "5968",
	"./logo.png": "a1d8",
	"./mall.png": "9183",
	"./page-banner.png": "f6fe",
	"./pro-act1.png": "185f",
	"./pro-act2.png": "f6fd",
	"./pro-act3.png": "1f89",
	"./pro-act4.png": "3ccc",
	"./pro-act5.png": "4768",
	"./pro-act6.png": "398f",
	"./pro1.png": "2443",
	"./pro2.png": "1e57",
	"./pro3.png": "c2cc",
	"./pro4.png": "32f9",
	"./pro5.png": "66ba",
	"./pro6.png": "b5af",
	"./provider1.png": "458a",
	"./provider10.png": "6d12",
	"./provider11.png": "6bcc",
	"./provider12.png": "a5dc",
	"./provider13.png": "ab38",
	"./provider14.png": "c656",
	"./provider2.png": "0a90",
	"./provider3.png": "9003",
	"./provider4.png": "cc11",
	"./provider5.png": "3c57",
	"./provider6.png": "6c56",
	"./provider7.png": "9553",
	"./provider8.png": "e321",
	"./provider9.png": "7334",
	"./reason-bg.png": "6c32",
	"./reason-img.png": "9b92",
	"./reason-manage.png": "7fbc",
	"./reason-report.png": "b56b",
	"./reason-score.png": "35fb",
	"./reason-service.png": "3fe4",
	"./service1.png": "c1c7",
	"./service2.png": "9436",
	"./service3.png": "a49e",
	"./stimulate.png": "aff6",
	"./tel.png": "137e",
	"./top.png": "60fe",
	"./us-bg.png": "fc04",
	"./val-company-hover.png": "c653",
	"./val-company.png": "104a",
	"./val-employee-hover.png": "4f2a",
	"./val-employee.png": "6187",
	"./val-manage-hover.png": "41a7",
	"./val-manage.png": "238e",
	"./welfare1.png": "e5c9",
	"./welfare2.png": "74d1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "de3c";